import React from 'react';
import PropTypes from 'prop-types';
import { Headline3 } from '@cdm/quickenloans-library/lib';
import ArticleSingleCta from '../ArticleSingleCta'
import InfoBox from '../../Atoms/InfoBox';
import AccordionGroup from '../AccordionGroup';
import TrustPilotWidget from '../../Atoms/TrustPilotWidget';
import TableOfContent from '../TableOfContent/TableOfContent';
import ReadingSection from './ReadingSection/ReadingSection';
import { testAttributes, defaultContent, navigationMenu } from './Constants';
import { ratesArticlesContainer, infoBoxContainer, ctaContainer, faqContainer, trustPilot } from './RatesArticlesContent.module.scss';

const Headline3Component = ({ children }) => <Headline3>{children}</Headline3>;

const RatesArticlesContent = ({ content = defaultContent }) =>
{
    const ctaData = {
        ...content?.ctaData,
        headline: { tag: 'h3', Component: Headline3Component }
    };

    return (
        <div
            className={ratesArticlesContainer}
            data-testid={testAttributes.RATES_ARTICLES_CONTAINER}
        >          
            <TableOfContent {...navigationMenu} />
            
            <article>
                {content?.ctaData && <div className={ctaContainer}><ArticleSingleCta {...ctaData} /></div>}

                <ReadingSection />

                {content?.infoBox && <div className={infoBoxContainer}><InfoBox item={content.infoBox} /></div>}

                <div className={trustPilot}><TrustPilotWidget /></div>

                <div className={faqContainer} data-testid={testAttributes.RATES_ARTICLES_FAQ}>
                    <AccordionGroup
                        as="postfixList"
                        title={defaultContent?.faqData?.mainTitle}
                        description={defaultContent?.faqData?.description}
                        items={defaultContent?.faqData?.items}
                        testId={testAttributes.RATES_ARTICLES_FAQ}
                    />
                </div>
            </article>
        </div>
    )
};

export default RatesArticlesContent;
RatesArticlesContent.propTypes = {
    /** Article content to be displayed */
    content: PropTypes.arrayOf(PropTypes.object)
};
Headline3Component.propTypes = {
    children: PropTypes.node
};